import { create } from 'zustand';
import apiService from "../service/apiService";
import { getLocale } from "../../i18nInit";

const useDataStore = create((set,get) => ({
  message: null,
  video: null,
  questions: null,
  questionCategories: null,
  faqs: null,
  company: null,
  categoryId: 0,
  companyId: null,
  setCompany: (data) => {
    set((state) => {
      return { ...state, company: data };
    });
  },
  setCompanyId: (id) => {
    set((state) => {
      return { ...state, companyId: id };
    });
  },
  setCategoryId: (id) => {
    sessionStorage.setItem('categoryId', id);
    set((state) => {
      return { ...state, categoryId: id };
    });
  },
  resetAnswers: () => {
    const questions = get().questions;
    for (const key in questions) {
      questions[key].answer = false;
    }

    set((state) => {
      return { ...state, questions: questions };
    });

    sessionStorage.setItem('questions', JSON.stringify(questions));
  },
  resetAnswer: (id) => {
    const questions = get().questions;
    for (const key in questions) {
      if (questions[key] == id) {
        questions[key].answer = false;
      }
    }

    set((state) => {
      return { ...state, questions: questions };
    });

    sessionStorage.setItem('questions', JSON.stringify(questions));
  },
  sendAnswers: (data) => {
    const { token, email, fullName, phone, terms } = data;

    const dataForSending = {
      companyId: get().companyId,
      questions: [],
      caseUser: {
        name: fullName,
        email: email,
        phoneNumber: phone,
        terms: true
      },
      questionCategoryId: get().categoryId
    };

    const questions = get().questions?.filter(i => i.questionCategoryId == get().categoryId);

    if (questions) {
      questions.forEach(q => {
        if (q.type === 'checkbox' || q.type === 'radio' || q.type === 'button') {
          dataForSending.questions.push({ id: q.id, answer: q.answer.id.map(a => ({id: a})) });
        } else if (q.type === 'location' || q.type === 'department' || q.type === 'dropdown') {
          dataForSending.questions.push({ id: q.id, answer: [{ id: q.answer.text }] });
        } else {
          dataForSending.questions.push({ id: q.id, answer: [{ id: null, text: q.answer.text }] });
        }
      });
    }

    return apiService.post('/cases', dataForSending, token || sessionStorage.getItem('token'));
  },
  saveQuestion: (id, value, text) => {
    const updatedQuestions = get().questions;

    for (const key in updatedQuestions) {
      if (updatedQuestions[key]?.id == id) {
        updatedQuestions[key].answer = {id: value, text: text};
      }
    }

    set((state) => {
      return { ...state, questions: updatedQuestions };
    });

    sessionStorage.setItem('questions', JSON.stringify(updatedQuestions));
  },
  fetchData: async () => {
    try {
      const storedQuestions = sessionStorage.getItem('questions');

      let categoryId = sessionStorage.getItem('categoryId');

      if (!categoryId && window && window.location && window.location.href) {
        const currentUrl = window.location.href;
        categoryId = currentUrl.split('/').pop();

        const isСategoryIdNumber = !isNaN(categoryId);

        if (isСategoryIdNumber) {
          sessionStorage.setItem('categoryId', categoryId);
        }
      }

      if (get().companyId) {
        apiService.get(`/forms/${get().companyId}?locale=${getLocale()}`).then(data => {
          if (data.message) {
            set({message: data.message});
          } else {

            for (const key in data.form.questions) {
              data.form.questions[key].answer = false;
            }
            const dataFromServer = {...data.form};
            dataFromServer.companyId = get().companyId;
            dataFromServer.video = data.form.video || '';

            if (storedQuestions) {
              dataFromServer.questions = JSON.parse(storedQuestions);
            }

            if (categoryId) {
              dataFromServer.categoryId = categoryId;
            }

            set(dataFromServer);
          }
        }).catch(error => {
          console.error('Error executing the request:', error);
        });
      }
    } catch (error) {
      console.error('Error loading data:', error);
    }
  },
}));

export default useDataStore;
